import React, { useState } from "react";
import { Button, Typography, Stack, List, ListItem, ListItemText, ListItemIcon } from "@mui/material";
import { ArrowBack, ChevronRight } from "@mui/icons-material";
import * as Icons from "@mui/icons-material";

const DialogOptions = ({ dialogIsFinalOption, setDialogIsFinalOption, options, onChange }) => {
  const [currentOptions, setCurrentOptions] = useState(options);
  const [history, setHistory] = useState([]);
  const [items, setItems] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);

  const getIconComponent = (iconName) => {
    const IconComponent = Icons[iconName];
    return IconComponent ? <IconComponent color="primary" /> : null;
  };

  const handleSelect = (option) => {
    if (option.options?.length > 0) {
      setHistory((prev) => [...prev, currentOptions]);
      setItems((prev) => [...prev, option.label]);
      setCurrentOptions(option.options);
      setDialogIsFinalOption(false);
    } else {
      setSelectedValue(option.value);
      setDialogIsFinalOption(true);
      onChange(option.value);
    }
  };

  const handleBack = () => {
    if (history.length > 0) {
      const previousOptions = history[history.length - 1];
      setCurrentOptions(previousOptions);
      setHistory((prev) => prev.slice(0, -1));
      setItems((prev) => prev.slice(0, -1));
      setSelectedValue(null); // Limpa seleção para evitar confusões
      setDialogIsFinalOption(false);
    }
  };

  return (
    <div>
      <Stack direction="row" spacing={1} alignItems="center" mb={1}>
        <Typography variant="body2" color="textSecondary" sx={{ flex: 1 }}>
          {items.length > 0 ? items.join(" > ") : dialogIsFinalOption ? '' : "Escolha uma opção:"}
        </Typography>
      </Stack>

      {history.length > 0 && (
        <Button onClick={handleBack} color="secondary" startIcon={<ArrowBack />}>
          Voltar
        </Button>
      )}

      <List>
        {currentOptions.map((option) => (
          <ListItem
            key={option.value}
            component="div"
            onClick={() => handleSelect(option)}
            sx={{
              cursor: "pointer",
              p: 0.5,
              mb: 0.5,
              borderRadius: 1,
              bgcolor: selectedValue === option.value ? "#b2b1b1" : "action.hover",
              color: selectedValue === option.value ? "#000000" : "inherit",
              "&:hover": {
                bgcolor: selectedValue === option.value ? "#b2b1b1" : "#eeeeee",
              },
            }}
          >
            {/* Ajustando o ícone */}
            <ListItemIcon sx={{ mr: -2 }}>
              {getIconComponent(option.icon)}
            </ListItemIcon>
            {/* Ajustando a distância entre o ícone e a label */}
            <ListItemText primary={option.label} sx={{ m: 0 }} />
            {option.options?.length > 0 && <ChevronRight color="action" />}
          </ListItem>
        ))}
      </List>
    </div>
  );
};

export default DialogOptions;
